import React, { useEffect, useState } from "react";
import { FileText, ArrowUpRight } from "lucide-react";
import api, { API_BASE } from "@/lib/api";

const fmtDate = (iso) => {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString(undefined, {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  } catch {
    return "";
  }
};

// Shows the top pinned family document (or newest if none pinned)
// under the countdown clock on the Landing page.
export default function FeaturedDocument() {
  const [doc, setDoc] = useState(null);

  useEffect(() => {
    let cancelled = false;
    api
      .get("/documents")
      .then((r) => {
        if (cancelled) return;
        const list = r.data || [];
        if (!list.length) return;
        const pinned = list.find((d) => d.pinned);
        setDoc(pinned || list[0]);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  if (!doc) return null;

  const updated = fmtDate(doc.uploaded_at);

  return (
    <a
      href={`${API_BASE}/documents/file/${doc.path}`}
      target="_blank"
      rel="noopener noreferrer"
      className={
        "relative mt-6 group inline-flex items-center gap-3 rounded-2xl bg-white/90 backdrop-blur border pl-4 pr-2 py-3 md:pl-5 md:pr-3 md:py-3.5 shadow-[0_4px_20px_-4px_rgba(44,42,38,0.08)] hover:shadow-[0_10px_30px_-10px_rgba(26,41,71,0.35)] transition-all max-w-full " +
        (doc.pinned
          ? "border-[#e7c96b] hover:border-[#d4a935]"
          : "border-[#e6e2d6] hover:border-[#1a2947]/40")
      }
      data-testid="featured-document-card"
    >
      {doc.pinned && (
        <span
          className="absolute -top-2 left-5 bg-[#e7c96b] text-[#5a4310] text-[10px] tracking-[0.16em] uppercase font-semibold px-2 py-0.5 rounded-full"
          data-testid="featured-document-please-read"
        >
          Please read
        </span>
      )}
      <div className="h-10 w-10 shrink-0 rounded-xl bg-[#faf7ef] border border-[#eae5d9] flex items-center justify-center text-[#1a2947]">
        <FileText className="h-5 w-5" />
      </div>
      <div className="min-w-0 pr-2">
        <div
          className="label-eyebrow text-[#8a7a3a]"
          data-testid="featured-document-eyebrow"
        >
          {doc.pinned ? "Pinned document" : "Family document"}
        </div>
        <div
          className="font-serif text-base md:text-lg text-stone-900 truncate max-w-[220px] md:max-w-[320px]"
          data-testid="featured-document-title"
        >
          {doc.title || doc.filename}
        </div>
        {updated && (
          <div
            className="text-[11px] text-stone-500 mt-0.5 tabular-nums"
            data-testid="featured-document-updated"
          >
            Updated {updated}
          </div>
        )}
      </div>
      <span
        className="ml-1 shrink-0 inline-flex items-center gap-1 rounded-full bg-[#1a2947] text-white text-xs font-semibold px-3 py-2 group-hover:bg-[#0f1a2e]"
        data-testid="featured-document-open-btn"
      >
        Open <ArrowUpRight className="h-3.5 w-3.5" />
      </span>
    </a>
  );
}
